export default {
  header: {
    // 顶部
    projectTitle:
      'Multi Energy Complementary MW Level Modular Distributed Energy System Project',
    expand: 'Expand',
    shrink: 'Shrink',
    searchMenu: 'Search Menu',
    fullScreen: 'Full screen',
    exitFullScreen: 'Exit full screen',
    darkTheme: 'Dark theme',
    defaulTtheme: 'Default theme',
    personalInfor: 'personal information',
    changeLangSuccess: 'Language switch succeeded',
  },
};
